import {Component, computed, inject, input, viewChild} from '@angular/core';
import {GenericChartComponent} from "../generic-chart/generic-chart.component";
import {FinanceDashboardChartType} from "../../enum/FinanceDashboardChartType";
import {TravelTypePieChartColorOptionsArray as PALETTE} from "../../constants/finance-dashboard-chart-options";
import {InsightQueriesPieChartNoLegendOptions} from "../../constants/insight-queries-chart-options";
import {InsightQueriesModalComponent} from "../insight-queries-modal/insight-queries-modal.component";
import {MatDialog} from "@angular/material/dialog";

interface ILegendItem {
  label: string;
  color: string;
  active: boolean;
}

@Component({
  selector: 'app-insight-queries',
  templateUrl: './insight-queries.component.html',
  styleUrls: ['./insight-queries.component.scss'],
  standalone: false,
})
export class InsightQueriesComponent extends GenericChartComponent {
  private readonly dialog = inject(MatDialog);

  protected readonly genericChart = viewChild.required(GenericChartComponent);

  public readonly labels = input.required<string[]>();

  public readonly showMoreBtn = input(true);

  public readonly isModalView = input(false);

  protected readonly insightOptions = computed(() =>
    this.showMoreBtn() ? InsightQueriesPieChartNoLegendOptions : InsightQueriesPieChartNoLegendOptions
  );

  protected readonly legends = computed<ILegendItem[]>(() => {
    const labels = this.labels().map((item, index) => ({
      label: item,
      color: PALETTE[index % PALETTE.length],
      active: false,
    }));
    return !this.showMoreBtn() ? labels : labels.slice(0, 5);
  });

  constructor() {
    super();
    this.chartConfiguration = {
      title: 'App insight queries',
      chartType: FinanceDashboardChartType.Pie,
      backGroundColor: PALETTE,
      borderColor: PALETTE,
    };
  }

  protected onLegendClick(item: ILegendItem, index: number) {
    const chart = this.genericChart().chart().chart;
    if (!chart || !chart.chart) return;
    item.active = !item.active;
    chart.chart.toggleDataVisibility(index);
    chart.chart.update();
  }

  protected onShowMoreClick() {
    const dialog = this.dialog.open(InsightQueriesModalComponent, {
      width: '55%',
    });
    dialog.componentInstance?.data.set(this.data);
    dialog.componentInstance?.presentationType.set(this.presentationType);
  }

}
